import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Admin from './components/Admin';
import Viewer from './components/Viewer';
import Inicio from './components/Inicio'; // Importamos el componente Inicio

function App() {
  return (
    <Router>
      <Routes>
        {/* Al iniciar sesión se redirige a la sección de Inicio */}
        <Route path="/" element={<Inicio />} />
        <Route path="/inicio" element={<Inicio />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/viewer" element={<Viewer />} />
      </Routes>
    </Router>
  );
}

export default App;
